export default __webpack_public_path__ + "static/media/familyplanning.9613c0af.jpg";